import React from "react";
import styled from "@emotion/styled";
import { Radio } from "../Radio";

import * as tokens from "../../design-tokens/tokens/tokens";

const SingleSelect = ({
  options,
  testId,
  radioGroupName,
}: SingleSelectProps) => {
  return (
    <Container data-testid={testId}>
      {options.map((option) => (
        <StyledRadio
          {...option}
          id={`${radioGroupName}-${option.text}`}
          key={option.value}
          label={option.text}
          value={option.value}
          /* Use the name attribute to group radio buttons
           * so that only one radio button can be selected at a time
           */
          name={radioGroupName}
        />
      ))}
    </Container>
  );
};

interface Option extends React.ComponentPropsWithoutRef<"input"> {
  value: string | number;
  text: string;
}

type SingleSelectProps = {
  options: Option[];
  testId: string;
  radioGroupName: string;
};

const StyledRadio = styled(Radio)`
  &.sr-radio {
    display: flex;
  }

  &.sr-radio > input[type="radio"] + label {
    border: 1px solid ${tokens.BRAND_HEROBLUE};
    color: ${tokens.BRAND_HEROBLUE};
    border-radius: 800px;
    padding: 17px 23px;
  }

  &.sr-radio > input[type="radio"]:focus + label {
    /* Needed to show selected radio when navigating with "tab" */
    box-shadow: 0 0 0 2px lightblue;
  }

  &.sr-radio > input[type="radio"]:hover + label {
    background: ${tokens.BRAND_HEROBLUE};
    color: ${tokens.WHITE};
  }

  &.sr-radio > input[type="radio"]:checked + label {
    background: ${tokens.BRAND_HEROBLUE};
    color: ${tokens.WHITE};
  }

  &.sr-radio > input[type="radio"] {
    /* Hide radio bullet and make it not use any screen space,
     * while maintaining accessibility.
     */
    position: absolute;
    opacity: 0;
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export type { SingleSelectProps };
export { SingleSelect };
